import { Component, OnInit, ViewEncapsulation} from '@angular/core';
import { BaseSelectionControl } from "../base-selection-control/base-selection-control.component";
import { NgClass } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LoggerService } from "@bequeathed/ngx-app-core";
import {QuestionUtils} from "../../../utils/question.utils";

const LOG: LoggerService = LoggerService.get('LinkControl');

/**
 * Control to present an option to follow a link for an action,
 * possibly on a 3rd party site.
 *
 * For example, opting to donate to a charity immediately instead of
 * leaving a gift in their Will
 *
 * @author Hayden Eastwell
 */
@Component({
    selector: 'link-control',
    standalone: true,
    imports: [
        NgClass,
        FormsModule,
        ReactiveFormsModule
    ],
    templateUrl: './link-control.component.html',
    styleUrls: [
        './link-control.component.sass',
        '../base-input-control/base-input-control.component.sass',
        '../../base-form/base-form.component.sass'
    ],
    encapsulation: ViewEncapsulation.None
})
export class LinkControl extends BaseSelectionControl implements OnInit {

    constructor() {
        super();

        this.inputType = 'confirm-option';
    }

    link = 'donate-now'
    later = 'maybe-later'

    override ngOnInit() {
        super.ngOnInit();
        LOG.debug('ngOnInit', 'Initializing LinkControl');

        const acceptedValues = this.question.acceptedValues;
        const keys = [...acceptedValues.keys()];
        this.link = keys[0];
        this.later = keys[1];
    }

    override onValueChange(answer: string) {
        if (answer === this.link) {
            LOG.debug('onValueChange', `Opening link for LinkControl: ${this.link}`);
            window.open(this.getLink(), '_blank');
        }
        this.setModelValue(answer)
    }

    override displayValue(value: string): string {
        return QuestionUtils.getText('WILL', this.question, this.messages, value) || ''
    }

    buttonCode(code: string, defaultCode = 'btn.ok'): string {
        return this.messages.getText(code, defaultCode)
    }

    optionDisplayValue(value: string): string {
        return QuestionUtils.getOptionDisplayValue('WILL', this.question, this.messages, value)
    }

    getLink(value?: string): string {
        const link = QuestionUtils.getLink('WILL', this.question, this.messages, value)
        LOG.info('getLink',`Link: ${link}`)
        return link
    }

}
